// extracted by mini-css-extract-plugin
module.exports = {"root":"_c9da3f"};